import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { deleteCharacterLike, saveCharacterLike } from '~/api';
import useToast from '~/store/useToast';
import useUpdateCharacterLike, {
  UpdateCharacterLikeMutationType,
  UpdateCharacterLikeRequest,
} from '../character/useUpdateCharacterLike';

const useCharacterLikeMutation = () => {
  const { showToast } = useToast();
  const { handleUpdateCharacterLike } = useUpdateCharacterLike();
  return useMutation({
    mutationFn: async ({
      operation,
      character_id,
    }: UpdateCharacterLikeRequest & {
      operation: UpdateCharacterLikeMutationType;
    }) =>
      operation === 'like'
        ? saveCharacterLike({ character_id })
        : deleteCharacterLike({ character_id }),
    onMutate: ({ operation, ...request }) => {
      try {
        handleUpdateCharacterLike(operation, request);
      } catch {
        showToast(
          'error',
          "We couldn't process your like action. Please try again later.",
        );
      }
    },
    onError: (error, { operation, ...request }) => {
      console.error(error);
      showToast(
        'error',
        operation === 'like'
          ? "We couldn't save your like for this character. Please try again later."
          : "We couldn't remove your like from this character. Please try again later.",
      );
      handleUpdateCharacterLike(
        operation === 'like' ? 'unlike' : 'like',
        request,
      );
    },
  });
};

export default useCharacterLikeMutation;
